import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SUBSCRIPTIONS_FEATURE_KEY,
  State,
  SubscriptionsPartialState,
  subscriptionsAdapter
} from './subscriptions.reducer';
import { IProductV2 } from '@care-portals/api-interfaces';

export const getSubscriptionsState = createFeatureSelector<
  SubscriptionsPartialState,
  State
>(SUBSCRIPTIONS_FEATURE_KEY);

const { selectAll, selectEntities } = subscriptionsAdapter.getSelectors();

export const getSubscriptionsLoading = createSelector(
  getSubscriptionsState,
  (state: State) => state.loading
);

export const getSubscriptionsLastFetch = createSelector(
  getSubscriptionsState,
  (state: State) => state.fetched
);

export const getSubscriptionsError = createSelector(
  getSubscriptionsState,
  (state: State) => state.error
);

export const getDiscountModal = createSelector(
  getSubscriptionsState,
  (state: State) => state.discountModal
);

export const getAllSubscriptions = createSelector(
  getSubscriptionsState,
  (state: State) => selectAll(state)
);

export const getSubscriptionsEntities = createSelector(
  getSubscriptionsState,
  (state: State) => selectEntities(state)
);

export const getSelectedSubscriptionId = createSelector(
  getSubscriptionsState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getSubscriptionsEntities,
  getSelectedSubscriptionId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const selectCurrentSubscription = createSelector(
  getSubscriptionsEntities,
  getSelectedSubscriptionId,
  (entities, subscriptionId) =>
    subscriptionId ? entities[subscriptionId] : null
);

export const hasMore = createSelector(
  getSubscriptionsState,
  (state: State) => state.hasMore
);

export const getActiveDigitalSubscriptions = createSelector(
  getSubscriptionsState,
  (state: State) =>
    Object.values(state.entities).filter(
      subscription =>
        (subscription?.product as IProductV2)?.type === 'digital' &&
        subscription?.status === 'active'
    )
);

export const getActivePhysicalSubscriptions = createSelector(
  getSubscriptionsState,
  (state: State) =>
    Object.values(state.entities).filter(
      subscription =>
        (subscription?.product as IProductV2)?.type === 'physical' &&
        subscription?.status === 'active'
    )
);
